import { InventoryReturnRequest, Order } from '../../../../../../clients/quipli-service/order/order';
import { CalculateOverageChargeResult } from '../../../../../../clients/quipli-service/product/product';
import { FuelCharge } from '../../../shared/types/fuel-charge-types';

export const OffRentGridHeader = ({
  order,
  showInventoryReturn,
  inventoryReturnRequest,
  fuelCharges,
  hourOverages,
}: {
  order: Order;
  showInventoryReturn: boolean | undefined;
  inventoryReturnRequest: InventoryReturnRequest | undefined;
  fuelCharges: FuelCharge[];
  hourOverages: CalculateOverageChargeResult[];
}) => {
  return (
    <>
      {/* col 1 & 2 */}
      <label className={`col-span-2`}>Products</label>
      {/* col 3 */}
      {showInventoryReturn && inventoryReturnRequest?.orderProductIds?.length ? <label>Return</label> : <div></div>}
      <>
        {/* col 4 */}
        {!order.isCycleBilled ? (
          <div>
            <label>Original Price</label>
          </div>
        ) : (
          <div></div>
        )}

        {/* col 5 */}
        <label>
          {order.isCycleBilled &&
          (fuelCharges.some((fc) => fc.amount > 0) || hourOverages?.some((ho) => ho.overageCharge > 0))
            ? 'Total'
            : order.isCycleBilled
            ? ''
            : 'Late Charge'}
        </label>

        {/* col 6 */}
        <label>{order.isCycleBilled ? '' : 'Total'}</label>
      </>
    </>
  );
};
